var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.downloadLoading,
          expression: "downloadLoading",
        },
      ],
      staticClass: "task-config-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "div",
            {
              staticClass: "menu-bar",
              staticStyle: { "margin-bottom": "12px" },
            },
            [
              _c(
                "el-menu",
                {
                  staticClass: "horizontal-menu",
                  attrs: {
                    mode: "horizontal",
                    "default-active": _vm.activeMenu,
                  },
                  on: { select: _vm.handleMenuSelect },
                },
                [
                  _c("el-menu-item", { attrs: { index: "basic" } }, [
                    _vm._v("基础帖审核"),
                  ]),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "premium" } }, [
                    _vm._v("优质帖审核"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "选择任务", clearable: "" },
                      model: {
                        value: _vm.searchForm.taskId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "taskId", $$v)
                        },
                        expression: "searchForm.taskId",
                      },
                    },
                    _vm._l(_vm.actLists, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.taskName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入会员卡号", clearable: "" },
                    model: {
                      value: _vm.searchForm.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cardNo", $$v)
                      },
                      expression: "searchForm.cardNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "发帖开始日期",
                      "end-placeholder": "发帖结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    on: { change: _vm.changeTime },
                    model: {
                      value: _vm.times,
                      callback: function ($$v) {
                        _vm.times = $$v
                      },
                      expression: "times",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "人工审核状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未审核", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "人工已审核", value: "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.action,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "action", $$v)
                        },
                        expression: "searchForm.action",
                      },
                    },
                    [
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: { label: "待审核", value: "1" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: { label: "系统审核通过", value: "2" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: { label: "系统审核不通过", value: "3" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: { label: "审核通过不发奖励", value: "4" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: { label: "人工审核通过", value: "6" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: { label: "人工审核不通过", value: "5" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: {
                              label: "人工审核通过不发奖励",
                              value: "7",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c("el-option", {
                            attrs: { label: "已发放奖励", value: "8" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "premium"
                        ? _c("el-option", {
                            attrs: { label: "优质帖待审核", value: "9" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "premium"
                        ? _c("el-option", {
                            attrs: { label: "优质帖审核通过", value: "10" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "premium"
                        ? _c("el-option", {
                            attrs: { label: "优质帖审核不通过", value: "11" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeMenu == "premium"
                        ? _c("el-option", {
                            attrs: { label: "优质奖励已发放", value: "12" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.postAllreward },
                    },
                    [_vm._v("批量发放奖励")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  align: "center",
                  width: "60",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员卡号", prop: "cardNo", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员名称", prop: "userName", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "员工姓名",
                  prop: "officerName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "任务名称", prop: "taskName", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "发帖时间",
                  prop: "createTime",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", prop: "action", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.action == 1
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("待审核"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 2
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("系统审核通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 3
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("系统审核不通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 4
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("审核通过不发奖励"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 5
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("人工审核不通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 6
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("人工审核通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 7
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("人工审核通过不发奖励"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 8
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("已发放奖励"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 9
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("优质帖待审核"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 10
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("优质帖审核通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 11
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("优质帖审核不通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.action == 12
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("优质奖励已发放"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "审核原因", prop: "remark", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.remark != "" &&
                        scope.row.remark.violationError &&
                        scope.row.remark.violationError != ""
                          ? _c("div", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(scope.row.remark.violationError)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.remark != "" &&
                        scope.row.remark.contentError &&
                        scope.row.remark.contentError != ""
                          ? _c("div", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(scope.row.remark.contentError)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.remark != "" &&
                        scope.row.remark.linkError &&
                        scope.row.remark.linkError != ""
                          ? _c("div", [
                              _vm._v(_vm._s(scope.row.remark.linkError)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.remark != "" &&
                        scope.row.remark.keywordError &&
                        scope.row.remark.keywordError != ""
                          ? _c("div", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(scope.row.remark.keywordError)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.remark != "" &&
                        scope.row.remark.warn &&
                        scope.row.remark.warn != ""
                          ? _c("div", [_vm._v(_vm._s(scope.row.remark.warn))])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "审核备注",
                  prop: "auditRemark",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  fixed: "right",
                  width: "210",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "5px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.postDetail(scope.row, 0)
                                  },
                                },
                              },
                              [_vm._v("帖子")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "5px" } },
                          [
                            scope.row.matchPostId
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.postDetail(scope.row, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("相似帖子")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            scope.row.action <= 4 || scope.row.action == 9
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.postReview(scope.row, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("人工审核")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.action == 6 || scope.row.action == 10
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.postReward(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("发放奖励")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "帖子详情",
                "close-on-click-modal": true,
                visible: _vm.showPostDialog,
                width: "60%",
                "custom-class": "post-detail-dialog",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showPostDialog = $event
                },
              },
            },
            [
              _vm.postLoading
                ? _c(
                    "div",
                    {
                      staticStyle: { "text-align": "center", padding: "20px" },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-loading",
                        staticStyle: { "font-size": "24px" },
                      }),
                    ]
                  )
                : _vm.selectedPost
                ? _c("post-detail", { attrs: { post: _vm.selectedPost } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "人工审核",
            visible: _vm.showReviewDialog,
            width: "55%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showReviewDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "reviewFormRef",
              attrs: {
                model: _vm.reviewForm,
                rules: _vm.reviewFormRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onReviewStatusChange },
                      model: {
                        value: _vm.reviewForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.reviewForm, "status", $$v)
                        },
                        expression: "reviewForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "reject" } }, [
                        _vm._v("审核不通过"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "pass" } }, [
                        _vm._v("审核通过"),
                      ]),
                      _vm._v(" "),
                      _vm.activeMenu == "basic"
                        ? _c(
                            "el-radio",
                            { attrs: { label: "pass_no_reward" } },
                            [_vm._v("审核通过不发奖励")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "审核原因", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: "4" },
                    model: {
                      value: _vm.reviewForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.reviewForm, "remark", $$v)
                      },
                      expression: "reviewForm.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeMenu === "basic"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "帖子标签" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.reviewForm.qualityLevel,
                            callback: function ($$v) {
                              _vm.$set(_vm.reviewForm, "qualityLevel", $$v)
                            },
                            expression: "reviewForm.qualityLevel",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("优秀"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("普通"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("低质"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeMenu === "premium" && _vm.reviewForm.status == "pass"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择奖励", prop: "reward" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "reward-radio-group",
                          model: {
                            value: _vm.reviewForm.reward,
                            callback: function ($$v) {
                              _vm.$set(_vm.reviewForm, "reward", $$v)
                            },
                            expression: "reviewForm.reward",
                          },
                        },
                        _vm._l(_vm.extraRewards, function (item) {
                          return _c(
                            "el-group-item",
                            { key: item.id, staticClass: "reward-group-item" },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticClass: "reward-radio",
                                  attrs: { label: item.id },
                                },
                                [
                                  _c("div", { staticClass: "radio-top" }, [
                                    _c(
                                      "span",
                                      { staticClass: "reward-title" },
                                      [_vm._v(_vm._s(item.ladderCount))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "reward-info" }, [
                                    item.rewardType == 1
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(item.rewardValue) + "积分"
                                          ),
                                        ])
                                      : item.rewardType == 2
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            item.couponList,
                                            function (value) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    value.couponId ||
                                                    value.couponName,
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(value.couponName)
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : item.rewardType == 3
                                      ? _c("div", [
                                          _vm._v(_vm._s(item.rewardValue)),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "任务信息" } }, [
                _vm.currentRow
                  ? _c("div", [
                      _vm._v(
                        "\n                任务名称：" +
                          _vm._s(_vm.currentRow.taskName) +
                          "；\n                任务基础领取次数：" +
                          _vm._s(_vm.currentRow.limitTimes) +
                          "； \n                任务时间：" +
                          _vm._s(_vm.taskTimeDisplay) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "人员参与信息" } }, [
                _vm.currentRow
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.rewardNum) + "\n                "),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showReviewDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitReview } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }